import { Fragment } from "react";
import HeaderSection from "../header/header.component";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { netural50, neturalBlack } from "../../constants/color";
import CustomerCard from "../customer-card/customer-card.component";
import CustomLabel from "../shared/label/custom-label.component";
import PaymentDetail from "../payment-detail/payment-detail.component";
import OrderDetail from "../order-detail/order-detail.component";
import SalesProductList from "../sales-product-list/sales-product-list.component";
import TransferInfo from "../transfer-info/transfer-info.component";
import {
  FETCH_ORDER_DETAILS,
  UPDATE_ORDER_STATUS,
} from "../../services/graphql/sales";
import { useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useState } from "react";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";
import { useSelector } from "react-redux";
import { ORDER_CONFIRM_MODAL_MESSAGE } from "../../constants/constant";
import UpdateOrderStatus from "../update-order-status-section/update-order-status-section.component";
import CustomButton from "../button/button.component";
import GlobalModal from "../modal-popup/global-modal";

const SalesProductDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const businesprofile = useSelector((state) => state.businesprofile);
  const [userInfo, setUserInfo] = useState({});
  const [orderInfo, setOrderInfo] = useState({});
  const [paymentDetail, setPaymentDetail] = useState({});
  const [transferInfo, setTransferInfo] = useState(null);
  const [fulfillmentOption, setFulfillmentOption] = useState("");
  const [pickupOrders, setPickupOrders] = useState({});
  const [deliveryOrders, setDeliveryOrders] = useState([]);
  const [isLoading, setISLoading] = useState(true);
  const [orderData, setOrderData] = useState({});
  const [orderStatus, setOrderStatus] = useState({});
  const [isVisibleConfirmModal, setIsVisibleConfirmModal] = useState(false);
  const [confirmModalContent, setConfirmModalContent] = useState({});
  let type = "";

  const getConfirmModalContent = (type) => {
    if (type === "Service") {
      return ORDER_CONFIRM_MODAL_MESSAGE.find(
        (item) => item.title === "Confirm Service Fulfillment"
      );
    } else {
      return ORDER_CONFIRM_MODAL_MESSAGE.find(
        (item) =>
          item.title === "Confirm Order Delivery" &&
          item.list[1].text.includes("delivery confirmation")
      );
    }
  };

  const groupProductsByPickupLocation = (products, option) => {
    return products.reduce(
      (acc, product) => {
        const isPickupEnabled = option === "pickup" ? true : false;
        const isDeliveryEnabled = option === "delivery" ? true : false;

        if (isPickupEnabled) {
          const pickupAddress =
            product.fulfillmentOption?.address || "No Pickup Location";
          if (!acc.pickup[pickupAddress]) {
            acc.pickup[pickupAddress] = [];
          }
          acc.pickup[pickupAddress].push(product);
        } else if (isDeliveryEnabled) {
          acc.delivery.push(product);
        }

        return acc;
      },
      { pickup: {}, delivery: [] }
    );
  };

  const [fetchOrderDetails, { loading: loadingOrderDetails }] = useLazyQuery(
    FETCH_ORDER_DETAILS,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (data && data.fetchOrderDetails) {
          let orderData = data.fetchOrderDetails;
          // console.log("List------------------", orderData);
          type = orderData.type;
          setOrderData(orderData);
          setOrderStatus(
            orderData.status === "reported" || orderData.status === "resolved"
              ? "completed"
              : orderData.status
          );
          setUserInfo(orderData.userInfo);
          setOrderInfo(orderData.orderInfo);
          setPaymentDetail(orderData.paymentSummary);
          setTransferInfo(orderData.transferInfo);
          // setMedia(orderData.paymentSummary.itemInfo);
          setFulfillmentOption(orderData.paymentSummary.fulfillmentType);
          const { pickup, delivery } = groupProductsByPickupLocation(
            orderData.paymentSummary.itemInfo,
            orderData.paymentSummary.fulfillmentType
          );
          // console.log("List------------------", pickup, delivery);
          setPickupOrders(pickup);
          setDeliveryOrders(delivery);
          setISLoading(false);

          const confirmModalContents = getConfirmModalContent(orderData.type);
          setConfirmModalContent(confirmModalContents);
        }
      },
      onError: (error) => {
        setISLoading(false);
        toast.error(error.message, {
          style: { width: "450px" },
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored ",
        });
        navigate("/sales");
      },
    }
  );

  const [updateOrderStatus, { loading: loadingUpdateOrderStatus }] =
    useMutation(UPDATE_ORDER_STATUS, {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (data && data.updateOrderStatus) {
          const responseOrder = data.updateOrderStatus;
          if (responseOrder.success) {
            setIsVisibleConfirmModal(false);
            getOrderDetails();
          } else {
            alert(
              responseOrder.message ||
                "Something went wrong, please try again later!"
            );
          }
        }
      },
      onError(error) {
        alert(error.message || "Something went wrong, please try again later!");
      },
    });

  const handleStatusChange = (e) => {
    setOrderStatus(e.target.value);
  };

  const handleConfirmClick = async () => {
    const updateOrderStatusInput = {
      orderId: orderId,
      newStatus: orderStatus,
    };
    await updateOrderStatus({
      variables: {
        updateOrderStatusInput,
      },
    });
  };

  const getOrderDetails = () => {
    fetchOrderDetails({
      variables: {
        transactionId: orderId,
        providerId: businesprofile._id,
      },
    });
  };

  useEffect(() => {
    getOrderDetails();
  }, [orderId]);

  return (
    <div
      className="main-div-right-section"
      style={{ backgroundColor: "white" }}
    >
      <Fragment>
        <HeaderSection currentTab={"Sales"} />
        <div className="second-section-style">
          {loadingOrderDetails || isLoading ? (
            <div style={{ marginTop: "4%" }}>
              <LoadingSpinner overlay={false} />
            </div>
          ) : (
            <Fragment>
              <Row>
                <Col
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  style={{
                    paddingLeft: "0px",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "2%",
                  }}
                >
                  <label
                    style={{
                      fontSize: "22px",
                      fontWeight: "bold",
                      color: neturalBlack,
                    }}
                  >
                    Order ID #{orderId}
                  </label>
                </Col>
                <Col lg="5" md="5" sm="5" xs="5" style={{ paddingLeft: 0 }}>
                  {/* Customer section for sales */}
                  <CustomerCard userInfo={userInfo} />
                  {/* Order detail section */}
                  <OrderDetail orderInfo={orderInfo} />
                  {/* Payment summary section */}
                  <PaymentDetail paymentDetail={paymentDetail} type={type} />
                  {/* Transfer info section - shows after order completion */}
                  <TransferInfo transferInfo={transferInfo} />
                  {/* Update order status section */}
                  <UpdateOrderStatus
                    orderData={orderData}
                    handleStatusChange={handleStatusChange}
                    orderStatus={orderStatus}
                    handleButtonClick={() => setIsVisibleConfirmModal(true)}
                    loadingUpdateOrderStatus={loadingUpdateOrderStatus}
                    sectionTitle="Confirm Order Delivery"
                    sectionDescription="You are about to mark this order as Completed. Once confirmed:"
                  />
                </Col>
                <Col lg="1" md="1" sm="1" xs="1"></Col>
                <Col lg="6" md="6" sm="6" xs="6" style={{ paddingLeft: 0 }}>
                  {Object.entries(pickupOrders).map(
                    ([pickupAddress, group], index) => (
                      <div
                        key={index}
                        className="mb-4"
                        style={{
                          border: "solid 1px #DADADA",
                          borderRadius: "16px",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            marginBottom: "5px",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: netural50,
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                            padding: "3%",
                          }}
                        >
                          <CustomLabel style={{ fontWeight: 600 }}>
                            Pickup at:
                          </CustomLabel>
                          <CustomLabel style={{ fontWeight: "normal" }}>
                            {pickupAddress}
                          </CustomLabel>
                        </div>
                        <SalesProductList
                          media={group}
                          fulfillmentOption={fulfillmentOption}
                        />
                      </div>
                    )
                  )}
                  {/* Render products with delivery enabled */}
                  {deliveryOrders.length > 0 && (
                    <SalesProductList
                      media={deliveryOrders}
                      fulfillmentOption={fulfillmentOption}
                    />
                  )}
                </Col>
              </Row>
            </Fragment>
          )}
        </div>
      </Fragment>
      {isVisibleConfirmModal && (
        <GlobalModal
          show={isVisibleConfirmModal}
          onClose={() => setIsVisibleConfirmModal(false)}
          showHeaderBorder={false}
          subtitle={confirmModalContent?.title || ""}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              marginBottom: "1%",
            }}
          >
            {confirmModalContent?.description}
          </p>
          {confirmModalContent?.list?.map((item) => (
            <label
              key={item.id}
              style={{
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "24px",
              }}
            >
              • {item.text}
            </label>
          ))}
          <CustomButton
            title={"Mark as Completed"}
            handleButtonClick={handleConfirmClick}
            customStyle={{ marginTop: "6%" }}
            loading={loadingUpdateOrderStatus}
          />
        </GlobalModal>
      )}
    </div>
  );
};

export default SalesProductDetail;
